module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-300.02bf068c.eot";